// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-1jaMY";
var _4 = "mostPopular-3R82i";
var _5 = "bottomPrice-1GQLU";
var _6 = "content-1IDfm";
var _7 = "contentFlex-3Dnww";
var _8 = "priceOnly-1Xg62";
var _9 = "bold-FgklP";
var _a = "regular-2L5t6";
var _b = "light-3hfKT";
var _c = "link-3RgyE";
var _d = "button-2ZscD";
var _e = "price-2Vlf0";
var _f = "forAllPassengers-3w0Sh";
var _10 = "money-3nO9f";
var _11 = "label-59N34";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "mostPopular", _5 as "bottomPrice", _6 as "content", _7 as "contentFlex", _8 as "priceOnly", _9 as "bold", _a as "regular", _b as "light", _c as "link", _d as "button", _e as "price", _f as "forAllPassengers", _10 as "money", _11 as "label" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "mostPopular": _4, "bottomPrice": _5, "content": _6, "contentFlex": _7, "priceOnly": _8, "bold": _9, "regular": _a, "light": _b, "link": _c, "button": _d, "price": _e, "forAllPassengers": _f, "money": _10, "label": _11 }
